import React from 'react'
import Header from '../../components/header'

export default function Settings() {
  return (
    <div>
      <Header/>
      Settings</div>
  )
}
